import React from "react";
import PropTypes from "prop-types";

const GridRow = ({ children, className }) => {
  return <div className={className}>{children}</div>;
};

GridRow.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

GridRow.defaultProps = {
  className: "",
};

export default GridRow;
